import { Row, Col, Form } from 'react-bootstrap';
import useGenerateReport from '../hooks/useGenerateReport';
import moment from 'moment';
import DatePicker from '../../common/DatePicker';
import '../index.scss';

const RecursiveContainer = ({ config, formikErr, handleChangeFormik }) => {
  const { updateValueOnFieldChange } = useGenerateReport();
  //console.log('formikErr :', formikErr);
  const handleChange = (isMandatory, e, boolValue) => {
    //console.log(
    //'e dekho',
    //e.target?.type,
    //e.target.value,
    //e.target.name,
    //e.target.checked,
    //boolValue,
    //);
    handleChangeFormik(e);
    if (e.target?.type === 'checkbox') {
      updateValueOnFieldChange(
        isMandatory,
        e?.target?.name,
        String(e.target.checked).toUpperCase(),
      );
    } else {
      updateValueOnFieldChange(
        isMandatory,
        e?.target?.name,
        e?.target?.type === 'radio'
          ? String(boolValue).toUpperCase()
          : e?.target?.value,
      );
    }
  };

  const getFormattedDate = (comingDate) => {
    const date = new Date(comingDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
    //return `${month}/${day}/${year}`;
  };

  const builder = (individualConfig) => {
    if (individualConfig?.isDisplay === false) return '';
    switch (individualConfig.dataType) {
      case 'Integer':
        return (
          <>
            <Col>
              <Form.Group controlId={individualConfig.name}>
                <Form.Label>
                  {individualConfig.displayName}{' '}
                  {individualConfig.isRequired === 'true' && (
                    <span className="required-mark">*</span>
                  )}
                </Form.Label>

                <Form.Control
                  type="number"
                  className=""
                  placeholder=""
                  spellCheck="off"
                  autoCorrect="off"
                  autoComplete="off"
                  name={individualConfig.name}
                  autoFocus={false}
                  defaultValue={individualConfig?.defaultValue}
                  value={
                    individualConfig.value === 'null'
                      ? null
                      : individualConfig.value
                  }
                  //required={individualConfig.isRequired === "true"}
                  onChange={(e) =>
                    handleChange(individualConfig.isRequired === 'true', e)
                  }
                  isInvalid={formikErr[individualConfig.name]}
                />
                <Form.Control.Feedback type="invalid">
                  {formikErr[individualConfig.name] && (
                    <Form.Text className="text-danger">
                      {formikErr[individualConfig.name]}
                    </Form.Text>
                  )}
                  {/*<span role="alert">
                    { touched.description && errors.description }
                  </span> */}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </>
        );
      case 'Double':
        return (
          <>
            <Col>
              <Form.Group controlId={individualConfig.name}>
                <Form.Label>
                  {individualConfig.displayName}{' '}
                  {individualConfig.isRequired === 'true' && (
                    <span className="required-mark">*</span>
                  )}
                </Form.Label>

                <Form.Control
                  type="number"
                  className=""
                  placeholder=""
                  spellCheck="off"
                  autoCorrect="off"
                  autoComplete="off"
                  name={individualConfig.name}
                  autoFocus={false}
                  defaultValue={individualConfig?.defaultValue || 0}
                  value={
                    individualConfig.value === 'null'
                      ? null
                      : individualConfig.value
                  }
                  //required={individualConfig.isRequired === "true"}
                  onChange={(e) =>
                    handleChange(individualConfig.isRequired === 'true', e)
                  }
                  isInvalid={formikErr[individualConfig.name]}
                />
                <Form.Control.Feedback type="invalid">
                  {formikErr[individualConfig.name] && (
                    <Form.Text className="text-danger">
                      {formikErr[individualConfig.name]}
                    </Form.Text>
                  )}
                  {/*<span role="alert">
                  { touched.description && errors.description }
                </span> */}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </>
        );
      case 'String':
      case 'Currency':
        return (
          <>
            <Col>
              <Form.Group controlId={individualConfig.name}>
                <Form.Label>
                  {individualConfig.displayName}{' '}
                  {individualConfig.isRequired === 'true' && (
                    <span className="required-mark">*</span>
                  )}
                </Form.Label>
                {individualConfig?.nameValuePair?.length > 0 ? (
                  <>
                    <Form.Control
                      as="select"
                      name={individualConfig.name}
                      value={individualConfig.value}
                      onChange={(e) =>
                        handleChange(individualConfig.isRequired === 'true', e)
                      }
                    >
                      {individualConfig?.nameValuePair.map((opt) => (
                        <option value={opt.Value} key={opt.Value}>
                          {opt.Name}
                        </option>
                      ))}
                    </Form.Control>
                  </>
                ) : (
                  <>
                    <Form.Control
                      type="text"
                      className=""
                      placeholder=""
                      spellCheck="off"
                      autoCorrect="off"
                      autoComplete="off"
                      name={individualConfig.name}
                      autoFocus={false}
                      defaultValue={individualConfig?.defaultValue}
                      value={individualConfig.value}
                      onChange={(e) =>
                        handleChange(individualConfig.isRequired === 'true', e)
                      }
                      isInvalid={formikErr[individualConfig.name]}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formikErr[individualConfig.name] && (
                        <Form.Text className="text-danger">
                          {formikErr[individualConfig.name]}
                        </Form.Text>
                      )}
                    </Form.Control.Feedback>
                  </>
                )}
              </Form.Group>
            </Col>
          </>
        );
      case 'Date':
        return (
          <>
            <Col>
              <Form.Group controlId={individualConfig.name}>
                <Form.Label>
                  {individualConfig.displayName}{' '}
                  {individualConfig.isRequired === 'true' && (
                    <span className="required-mark">*</span>
                  )}
                </Form.Label>

                <DatePicker
                  name={individualConfig.name}
                  showIcon={true}
                  selected={
                    individualConfig?.value
                      ? new Date(moment(individualConfig?.value))
                      : new Date(moment(individualConfig?.defaultValue))
                  }
                  //selected={new Date(individualConfig?.defaultValue)}
                  onChange={(date) => {
                    if (date) {
                      console.log(date);
                      updateValueOnFieldChange(
                        individualConfig.isRequired === 'true',
                        individualConfig.name,
                        moment(date).format('MM-DD-YYYY'),
                      );
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {formikErr[individualConfig.name] && (
                    <Form.Text className="text-danger">
                      {formikErr[individualConfig.name]}
                    </Form.Text>
                  )}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </>
        );
      case 'Boolean':
        return (
          <>
            {individualConfig.group !== 'Products' ? (
              <Col>
                <Form.Group controlId={individualConfig.name}>
                  <Form.Label>
                    {individualConfig.displayName}{' '}
                    {individualConfig.isRequired === 'true' && (
                      <span className="required-mark">*</span>
                    )}
                  </Form.Label>
                  <br />

                  {individualConfig.nameValuePair
                    .toReversed()
                    .map((ele, index) => (
                      <Form.Check
                        key={index}
                        inline
                        type="radio"
                        label={ele.Name}
                        id={`${individualConfig.displayName}-${ele.Name}`}
                        name={individualConfig.name}
                        defaultChecked={
                          ele.Value.toLowerCase() ===
                            individualConfig.defaultValue ||
                          ele.Value.toUpperCase() ===
                            individualConfig.defaultValue
                            ? true
                            : false
                        }
                        checked={
                          ele.Value.toLowerCase() === individualConfig.value ||
                          ele.Value.toUpperCase() === individualConfig.value ||
                          true === individualConfig.value
                            ? true
                            : false
                        }
                        //required={individualConfig.isRequired === "true"}
                        value={ele.Value}
                        onChange={(e) =>
                          handleChange(
                            individualConfig.isRequired === 'true',
                            e,
                            String(ele.Value).toLowerCase() === 'true',
                          )
                        }
                      />
                    ))}
                </Form.Group>
                <Form.Control.Feedback type="invalid">
                  {formikErr[individualConfig.name] && (
                    <Form.Text className="text-danger">
                      {formikErr[individualConfig.name]}
                    </Form.Text>
                  )}
                </Form.Control.Feedback>
              </Col>
            ) : (
              <Col className="col-auto reports-info-checkbox-container">
                <Form.Group controlId={individualConfig.name}>
                  {individualConfig.displayName === 'MM' && (
                    <Form.Label>
                      {individualConfig.group}{' '}
                      {individualConfig.isRequired === 'true' && (
                        <span className="required-mark">*</span>
                      )}
                    </Form.Label>
                  )}
                  <br />
                  <Form.Check
                    inline
                    type="checkbox"
                    className=""
                    label={individualConfig.displayName}
                    id={`${individualConfig.displayName}`}
                    name={individualConfig.name}
                    value={individualConfig.Value}
                    checked={
                      individualConfig?.value.toLowerCase() === 'true' ||
                      individualConfig?.value.toUpperCase() === 'TRUE' ||
                      true === individualConfig?.value
                        ? true
                        : false
                    }
                    onChange={(e) =>
                      handleChange(
                        individualConfig.isRequired === 'true',
                        e,
                        String(individualConfig.value).toLowerCase() === 'true',
                      )
                    }
                  />
                </Form.Group>
              </Col>
            )}
          </>
        );
      default:
        return <div>Unsupported field</div>;
    }
  };

  return (
    <>
      <Row className="row row-cols-2">
        {config.map((c) => {
          return builder(c);
        })}
      </Row>
    </>
  );
};

export default RecursiveContainer;
